<template>
  <div id="app">
    <router-view />
    <!-- <Index></Index> -->
  </div>
</template>

<script>
// import Index from '@/layout/index.vue';

export default {
  components: {
    // Index
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 表单校验提示不做换行继承，避免提示样式异常 */
#app .el-form-item__error,
#app .el-form-item__error * {
  white-space: normal !important;
}

/* append-to-body 场景补充（不在 #app 下的 el-dialog 弹窗文案） */
body .el-dialog__body {
  white-space: pre-line;
}

body .el-form-item__error,
body .el-form-item__error * {
  white-space: normal !important;
}

/* http://meyerweb.com/eric/tools/css/reset/ 
		v2.0 | 20110126
		License: none (public domain)
	*/
html {
  font-size: 16px;
  overflow-y: auto;
  // overflow-x: hidden;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
  width: 100vw;
  font-family: PingFang;
  background-color: #f9f8f9;
  // 字母数字换行
  word-wrap: break-word;
  word-break: break-all;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  text-decoration: none;
  color: #333;
}

img {
  vertical-align: middle;
}

input,
button,
select // ,

// textarea
 {
  outline: none;
}

// textarea {
//   resize: none;
// }

.more_text {
  font-size: 14px;
  color: #3b75dd;
  cursor: pointer;
  font-weight: 400;
}

.home_news_title {
  font-size: 36px;
  font-weight: 600;
  color: #323233;
}

.home_news_title_en {
  font-size: 22px;
  color: #cccccc;
  font-weight: 400;
}

// 通用样式
.common-title {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 56px;
}

.common-title .line {
  display: inline-block;
  width: 8px;
  height: 22px;
  margin-right: 13px;
  background: #2c97ff;
  border-radius: 4px;
}

.common-title .common-title-content {
  font-size: 22px;
  font-family: PingFang;
  font-weight: bold;
  color: #2c97ff;
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #2c97ff;
  border-radius: 3px;
}

*::-webkit-scrollbar {
  display: none;
}

// input类型为number时 去掉小箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}

input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}

.el-select-dropdown__item.selected {
  color: #2c97ff;
}

// .el-input__inner:focus {
//   // 输入框聚焦
//   border-color: #2c97ff;
// }
.el-textarea__inner:focus {
  border-color: #2c97ff;
}

.el-pagination .el-select .el-input .el-input__inner:hover {
  // 下拉框鼠标器移入
  border-color: #2c97ff;
}

.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #2c97ff;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2c97ff !important;
}

.noData2 {
  width: 100%;
  text-align: center;
  font-size: 24px;
  color: #2c97ff;
  margin-top: 20vh;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #181818;
}

.el-select .el-input.is-disabled .el-input__inner {
  background-color: transparent;
  color: #181818;
}

.html_content {
  img {
    // width: 825px;
    width: 100%;
    height: auto;
  }
}

.theDialogTitle {
  text-align: center;
  font-size: 15px;
  display: flex;
  align-items: center;

  div:first-child {
    width: 3px;
    height: 16px;
    background: #3b75dd;
  }

  div:last-child {
    margin-left: 10px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
  }
}

.el-dialog__headerbtn .el-dialog__close {
  font-weight: bold;
  font-size: 20px;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #3b75dd;
}

.el-dialog {
  border-radius: 10px;
}

.theDialogContent {
  max-height: 50vh;
  line-height: 22px;
  overflow-y: scroll;
}

.theDialogFooter {
  text-align: right;
  margin-top: 24px;

  .el-button--primary {
    width: 141px;
    height: 44px;
    background: #3b75dd;
    border-radius: 6px;
    border: none;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
  }
}
</style>
